import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const AddPaymentMethod = ({ buttonComponent, agentId, callback }) => {
    const [show, setShow] = useState(false);
    const [accountType, setAccountType] = useState(null);

    const handleClose = () => { setAccountType(null); setShow(false) };
    const handleShow = () => setShow(true);

    async function add() {
        loadingShow();
        let postData = {};
        if (accountType == 1) {
            postData = {
                accountType: accountType,
                bankDetails: {
                    "accountNumber": document.getElementById('accountNumber').value.trim(),
                    "ifscCode": document.getElementById('ifscCode').value.trim()
                }
            }
        }
        else if (accountType == 2) {
            postData = {
                accountType: accountType,
                upiDetails: {
                    "upiId": document.getElementById('upiId').value.trim()
                }
            }
        }
        let resp = await postApi(postData, urlApi?.addPaymentMethodOfAgent + agentId);
        loadingHide();
        if (resp.responseCode === 200) {
            callback?.();
            toast.success(resp.message);
            handleClose();
        } else {
            toast.error(resp.message);
        }

    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow}>{buttonComponent}</div>

            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Add Payment method of Agent</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className="mb-3">
                        <select name="" id="accountType" className='w-full px-3 py-2 rounded-md border-2 text-sm' onChange={(e) => setAccountType(e.target.value)}>
                            <option value="" disabled selected>Select Account Type</option>
                            <option value="1">Bank</option>
                            <option value="2">UPI</option>
                        </select>
                    </div>
                    {accountType && <p className="text-sm font-semibold mb-2">{accountType == 1 ? "Bank" : "UPI"} Details</p>}
                    {
                        accountType == 1 &&
                        <>
                            <div className="top-label-input-group mb-2">
                                <label htmlFor="accountNumber" className='text-sm font-semibold mb-1'>Account Number*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='accountNumber' />
                            </div>
                            <div className="top-label-input-group">
                                <label htmlFor="ifscCode" className='text-sm font-semibold mb-1'>IFSC CODE*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='ifscCode' />
                            </div>
                        </>
                    }

                    {
                        accountType == 2 &&
                        <div className="top-label-input-group">
                            <label htmlFor="upiId" className='text-sm font-semibold mb-1'>UPI ID*</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='upiId' />
                        </div>
                    }

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => add()}>Add</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddPaymentMethod